import Checkbox from '../../inputs/Checkboxes/Checkbox/Checkbox';

import classes from './ListCards.module.scss';

const ListCards = ({ className, items, showCheckbox, onCheck, itemCard, numberColumns, filterChecbox, useWideCards = false, useClientCards = false, useSuppliersCards = false }) => {
  // const containerClasses = [classes.container, numberColumns === 2 ? classes['two-columns'] : classes['one-column']];
  const containerClasses = [classes.container];
  let containerStyle = {};
  
  if (useWideCards) {
    containerClasses.push(classes['wide-cards']);
  } else if (useClientCards) {
    containerClasses.push(classes['client-cards']);
  } else if (useSuppliersCards) {
    containerClasses.push(classes['suppliers-cards']);
    // Estilos inline para suppliers
    containerStyle = {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(450px, 1fr))',
      gap: '20px',
      width: '100%'
    };
  }
  className && containerClasses.push(className);
  const wasItemChecked = items.find(item => item.isChecked);
  const typeItem = wasItemChecked ? wasItemChecked[filterChecbox] : '';
  
  return (
    <div className={containerClasses.join(' ')} style={containerStyle}>
      {items
        .filter(item => item.show !== false)
        .map((item, index) => {
          const cardItemStyle = useSuppliersCards ? {
            width: '500px',
            minWidth: '500px',
            maxWidth: '500px',
            boxSizing: 'border-box',
            flexShrink: 0
          } : {};
          
          return (
          <div key={index} className={`${classes['card-item']} ${item.isChecked ? classes['card-item--checked'] : ''}`} style={cardItemStyle}>
            {showCheckbox && (
              <Checkbox
                className={classes.check}
                id='isChecked'
                checked={item.isChecked}
                onClick={checked => onCheck(index, checked)}
                disabled={!!typeItem ? typeItem !== item[filterChecbox] : false}
                //disabled={true}
              />
            )}
            {itemCard(item, index)}
          </div>
          );
        })}
    </div>
  );
};

export default ListCards;
